import React from 'react';
import {FormattedMessage} from 'react-intl';
import messages from '../../../../res/translations/messages';
import BooleanFormatter from './BooleanFormatter';

const ShuffledExclusiveChoiceType = ({choices}) => (
    <table className="table table-sm">
        <thead>
            <tr>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.shuffled} /></th>
                <th scope="col"><FormattedMessage {...messages.surveys.form.label.exclusive} /></th>
            </tr>
        </thead>
        <tbody>
            {choices.map((choice) => (
                <tr key={choice.id}>
                    <td className="value-id">{choice.id}</td>
                    <td>{choice.value}</td>
                    <td><BooleanFormatter value={choice.shuffle} /></td>
                    <td><BooleanFormatter value={choice.exclusive} /></td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default ShuffledExclusiveChoiceType;
